import { Component } from '@angular/core';
import { faCheck } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { UserStatusEnum } from 'src/app/samwebDescription/samwin/UserStatusEnum';
import { SamwinUnreachableWarningSelectors } from 'src/app/store/notification/samwinUnreachableWarning/samwin-unreachable-warning.selectors';
import { ChangeSkillStatus } from 'src/app/store/samwin/samwin-skills/samwin-skills.actions';
import { SkillConstants } from 'src/app/store/samwin/samwin-skills/skill-constants';
import { RequestUserStatusChange } from 'src/app/store/samwin/samwin-user-status/samwin-user-status.actions';
import { Originator } from 'src/generated/signalR/originator';

@Component({
   selector: 'samweb-unreachable-toast',
   templateUrl: './unreachable-toast.component.html',
   styleUrls: ['./unreachable-toast.component.scss'],
})
export class UnreachableToastComponent extends Toast {
   constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, private store: Store) {
      super(toastrService, toastPackage);
      // Lint does not allow ngOnInit for this class
      this.isUnreachableBecauseOfUserstate$ = this.store.select(SamwinUnreachableWarningSelectors.isUnreachableBecauseOfUserstate);
      this.isUnreachableBecauseOfAgent$ = this.store.select(SamwinUnreachableWarningSelectors.isUnreachableBecauseOfDeactivated);
      this.isUnreachableBecauseOfSkills$ = this.store.select(SamwinUnreachableWarningSelectors.isUnreachableBecauseOfSkills);
   }
   public resolveIcon = faCheck;

   public isUnreachableBecauseOfUserstate$: Observable<boolean>;
   public isUnreachableBecauseOfAgent$: Observable<boolean>;
   public isUnreachableBecauseOfSkills$: Observable<boolean>;

   public resolve() {
      if (this.store.selectSnapshot(SamwinUnreachableWarningSelectors.isUnreachableBecauseOfUserstate)) {
         this.store.dispatch(new RequestUserStatusChange(UserStatusEnum.AVAILABLE.value, Originator.User));
      }
      if (this.store.selectSnapshot(SamwinUnreachableWarningSelectors.isUnreachableBecauseOfSkills)) {
         this.store.dispatch(new ChangeSkillStatus(SkillConstants.OVERALL_SKILL_ID, true, null));
      }
   }
}
